<template>
  <div class="reset-password ">
    <div class="form-wrapper">       
      <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <h1 class="text-3xl lg:text-5xl font-bold mb-8">
            Reset Password
          </h1>
          <ValidationProvider v-slot="{ errors }" rules="required|min:8">
            <input
              class="form-input"
              type="password"
              placeholder="New Password"
              name="Password"
              v-model="formData.password"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :rules="`required|min:8|match:${formData.password}`"
          >
            <input
              class="form-input"
              type="password"
              placeholder="Confirm Password"
              name="Password"
              v-model="formData.password_confirmation"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <div class="pt-8 md:pt-12">
            <button class="new-app-btn bg-blue">Submit</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'ResetPassword',
  data() {
    return {
      formData: {
        password: '',
        password_confirmation: ''
      }
    }
  },
  created() {
    if (!this.$route.params.id && !this.$route.params.token) {
      this.$router.push('/')
      this.$notify({
        group: 'buyHive',
        type: 'error',
        text: 'Id or Token is missing'
      });
    }
  },
  methods: {
    ...mapActions ([
      'resetPassword'
    ]),
    async onSubmit() {
      const payload = {
        formData: this.formData,
        id: this.$route.params.id,
        token: this.$route.params.token
      }
      const response = await this.resetPassword(payload)
      if (response.result) {
        this.$notify({
          group: 'buyHive',
          type: 'success',
          text: response.message
        });
        this.$router.push({name: 'Login'})
      } else {
        this.$notify({
          group: 'buyHive',
          type: 'error',
          text: response.message
        });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .reset-password {
    @apply mx-auto max-w-max pb-12 px-5;
    @screen md { @apply px-0 w-95 pt-12; }
    .form-wrapper {
      @apply bg-smoke-100 py-8 px-5 ;
      @screen md { @apply rounded-lg py-12 px-30; }
      max-width: 620px;
    }
  }
</style>